import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import "./_buildingCreationModal.scss";
import MultiSelect from "react-multi-select-component";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import moment from "moment";


const ADD_BUILDING_ROOMS_FLOORS_DETAILS = gql`
mutation($params:AddRoomsFloorsDetails){
    addRoomsFloorsDetails(params:$params)
}
`;


class BuildingCreationModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataClear: 1,
            branch_id: "",
            branchError: '',
            buildingName: "",
            buildingNameError: "",
            noOfFloors: "",
            noOfFloorsError: "",
            currentStep: 1,
            floorAndRoomDetails: [],
            getEmployees: [],
            submitError: "",
            displayedFloors: 0,
            deleteId: "",
            hostel_building_id: null,
            existingFloorAndRooms: [],


        }
    }

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                dataClear: 1,
                branch_id: "",
                branchError: '',
                buildingName: "",
                buildingNameError: "",
                noOfFloors: "",
                noOfFloorsError: "",
                currentStep: 1,
                floorAndRoomDetails: [],
                getEmployees: [],
                submitError: "",
                displayedFloors: 0,
                deleteId: "",
                hostel_building_id: null,
                existingFloorAndRooms: [],
            })

            if (this.props.stateData.existingBuildingCreationData.length > 0) {
                let existingData = this.props.stateData.existingBuildingCreationData;
                console.log("employeesData", existingData);
                let employeesData = []

                this.getEmployess(this.props.stateData.branchSearch)
                    .then((data) => {
                        console.log("data", data);
                        employeesData.push(...data)
                    })
                    .catch((error) => {
                        console.error("Error fetching data:", error);
                    });
                setTimeout(() => {
                    let data = [];
                    existingData[0].floors_details.map((item) => {

                        let selectedEmployees = []
                        if (item.floor_incharge_id != null) {

                            item.floor_incharge_id.split(",").map((item2) => {
                                let filterEmployees = employeesData.filter((item3) => item3.value == item2);
                                selectedEmployees.push(...filterEmployees)
                            })
                        }
                        data.push({
                            ...item,
                            capacityOfEachRooms: item.rooms_details[0].room_capacity,
                            floorNamesError: "",
                            noOfRooms: item.rooms_details.length,
                            selected_floor_incharge_details: selectedEmployees,
                            noOfRoomsError: "",
                            roomCapacityError: ""
                        })
                    })

                    this.setState({
                        branch_id: this.props.stateData.branchSearch,
                        buildingName: existingData[0].hostel_building_name,
                        noOfFloors: existingData[0].floors_details.length,
                        hostel_building_id: existingData[0].hostel_building_id,
                        floorAndRoomDetails: data,
                        existingFloorAndRooms: data,
                    })
                }, 1000);

            }

        }

        if (this.props.show == false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }

    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;

        let getArray = [];
        if (name == "branch") {

            if (value != "0") {
                let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    branch_id: value,
                    branchError: '',
                    buildingName: "",
                    buildingNameError: "",
                    noOfFloors: "",
                    noOfFloorsError: "",
                    floorAndRoomDetails: [],
                });

                this.getEmployess(value);

            } else {
                this.setState({
                    branch_id: '',
                    branchError: '',
                    buildingName: "",
                    noOfFloors: "",
                    buildingName: "",
                    buildingNameError: "",
                    noOfFloors: "",
                    noOfFloorsError: "",
                    floorAndRoomDetails: [],

                })
            }
        }

    };

    getEmployess = async (val) => {

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,){
                getEmployees(institute_id:$institute_id,branch_id:$branch_id){
                  employee_id
                  employee_name
                  employee_type_id
                }
              }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(val),
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getEmployees.length > 0) {
            let data = [];
            if (result.data.getEmployees.length > 0) {

                result.data.getEmployees.filter((item) => item.employee_type_id == 8).map((item) => {
                    let obj = {
                        label: item.employee_name,
                        value: item.employee_id
                    }
                    data.push(obj)
                })
            }
            this.setState({
                getEmployees: data,
            })

            return data
        }
    };

    selecthandleInputChange = (e, i) => {
        let name = e.target.name;
        let value = e.target.value;

        console.log("cccccc", name, value);

        if (name == "buildingName") {
            this.setState({
                buildingNameError: "",
                buildingName: value,
            })
        }

        if (name == "noOfFloors") {
            if (value <= 30) {
                let array = Array.from({ length: value }, (_, item) => {
                    return { hostel_building_floor_id: null, floor_name: `Floor ${item + 1}`, noOfRooms: "", capacityOfEachRooms: "", rooms_details: [], floor_incharge_id: "", noOfRoomsError: "", selected_floor_incharge_details: [], floorNamesError: "", floorInchargeError: "" }
                })
                this.setState({
                    floorAndRoomDetails: array,
                    noOfFloorsError: "",
                    noOfFloors: value
                })
            } else {
                this.setState({
                    floorAndRoomDetails: [],
                    noOfFloorsError: "",
                    noOfFloors: ""
                })
            }
        }

        if (name == "floor_name") {
            console.log("floor", this.state.floorAndRoomDetails, i);

            let floorData = [];

            this.state.floorAndRoomDetails.map((item, index) => {
                if (index == i) {
                    floorData.push({ ...item, floor_name: value, floorNamesError: "" })
                } else {
                    floorData.push({ ...item })
                }
            })

            this.setState({
                floorAndRoomDetails: floorData,
                room_capacity: "",
                room_name: "",
                rooms_details: [],
                floorNamesError: "",
            })
        }

        if (name == "noOfRooms") {
            console.log("rooms", this.state.floorAndRoomDetails, i, name, value);
            if (value != "0" && value != "" && value <= 20) {
                let floorData = [];
                this.state.floorAndRoomDetails.map((item, index) => {
                    if (index == i) {
                        floorData.push({ ...item, noOfRooms: value, noOfRoomsError: "", rooms_details: [], capacityOfEachRooms: "" })
                    } else {
                        floorData.push({ ...item })
                    }
                })
                this.setState({
                    floorAndRoomDetails: floorData,
                })

            } else {
                let floorData = [];
                this.state.floorAndRoomDetails.map((item, index) => {
                    if (index == i) {
                        floorData.push({ ...item, noOfRooms: "", rooms_details: [], capacityOfEachRooms: "" })
                    } else {
                        floorData.push({ ...item })
                    }
                })
                this.setState({
                    floorAndRoomDetails: floorData
                })
            }

        }

        if (name == "capacityOfEachRooms") {

            if (value != "0" && value != "") {

                let floorData = [];
                this.state.floorAndRoomDetails.map((item, index) => {
                    if (index == i) {
                        let array = Array.from({ length: item.noOfRooms }, (_, item) => {
                            let roomName = "";

                            if (item + 1 > 9) {
                                roomName = `${i + 1}${item + 1}`
                            } else {
                                roomName = `${i + 1}0${item + 1}`
                            }

                            return { room_id: null, room_name: roomName, room_capacity: value, roomNamesError: "", roomEachCapacityError: "" }
                        })

                        floorData.push({ ...item, capacityOfEachRooms: value, roomCapacityError: "", rooms_details: array })
                    } else {
                        floorData.push({ ...item })
                    }
                })

                this.setState({
                    floorAndRoomDetails: floorData,
                    floorNamesError: "",
                })
            } else {
                let floorData = [];
                this.state.floorAndRoomDetails.map((item, index) => {
                    if (index == i) {
                        floorData.push({ ...item, capacityOfEachRooms: "", rooms_details: [], roomCapacityError: "" })
                    } else {
                        floorData.push({ ...item })
                    }
                })

                this.setState({
                    floorAndRoomDetails: floorData,
                })
            }
        }

        if (name == "room_name") {
            console.log("roomsoooooo", this.state.floorAndRoomDetails, i, name, value);

            let array = [];

            this.state.floorAndRoomDetails.map((item, index) => {
                if (index == this.state.displayedFloors) {

                    console.log("item", item);
                    let roomsData = [];

                    item.rooms_details.map((item1, index) => {
                        if (index === i) {
                            roomsData.push({ ...item1, room_name: value, roomNamesError: "", roomEachCapacityError: "" })
                        } else {
                            roomsData.push({ ...item1 })
                        }
                    })
                    array.push({ ...item, rooms_details: roomsData })

                } else {
                    array.push({ ...item })
                }
            })

            console.log("array", array);

            this.setState({ floorAndRoomDetails: array })



        }

        if (name == "room_capacity") {
            let array = [];

            this.state.floorAndRoomDetails.map((item, index) => {
                if (index == this.state.displayedFloors) {

                    console.log("item", item);
                    let roomsData = [];

                    item.rooms_details.map((item1, index) => {
                        if (index === i) {
                            roomsData.push({ ...item1, room_capacity: parseInt(value), roomEachCapacityError: "" })
                        } else {
                            roomsData.push({ ...item1 })
                        }
                    })
                    array.push({ ...item, rooms_details: roomsData })

                } else {
                    array.push({ ...item })
                }
            })
            this.setState({ floorAndRoomDetails: array })

        }

    }

    getDisplayData = () => {

        if (this.state.branch_id == "") {
            this.setState({ branchError: 'Please select branch', });
            return true
        }

        if (this.state.buildingName == "") {
            this.setState({ buildingNameError: "Please Enter Building Name" })
            return true
        }


        let isError = false;

        this.state.floorAndRoomDetails.some((obj, i) => {
            let errorDetails = this.state.floorAndRoomDetails;
            console.log("errrr", errorDetails);


            if (obj.floor_name == "" || obj.floor_name == undefined) {
                errorDetails[i] = { ...obj, floorNamesError: "Please Enter Floor Name" }
                console.log("ggagga", errorDetails);
                this.setState({ floorAndRoomDetails: errorDetails })
                isError = true;
                return true
            }


            if (!obj.selected_floor_incharge_details.length) {
                console.log("selected", obj.selected_floor_incharge_details);
                errorDetails[i] = { ...obj, floorInchargeError: "Please Select Floor InCharge" };
                this.setState({ floorAndRoomDetails: errorDetails });
                isError = true;
                return true;
            }



            if (obj.noOfRooms == "" || obj.noOfRooms == undefined) {
                errorDetails[i] = { ...obj, noOfRoomsError: "Please Enter Number Of Rooms" }
                this.setState({ floorAndRoomDetails: errorDetails })
                isError = true;
                return true
            }


            if (obj.capacityOfEachRooms == "" || obj.capacityOfEachRooms == undefined) {
                errorDetails[i] = { ...obj, roomCapacityError: "Please Enter Room Capacity" }
                this.setState({ floorAndRoomDetails: errorDetails })
                isError = true;
                return true
            }

            let rooms_details = obj.rooms_details;
            obj.rooms_details.map((item, index) => {

                console.log("item", item);
                if (item.room_name == "" || item.room_name == undefined) {
                    rooms_details[index] = { ...item, roomNamesError: "Plase Enter Room Name" }
                    errorDetails[i] = { ...obj, rooms_details: rooms_details }
                    this.setState({ floorAndRoomDetails: errorDetails })
                    isError = true;
                    return true
                }

                if (item.room_capacity == "" || item.room_capacity == undefined) {
                    rooms_details[index] = { ...item, roomEachCapacityError: "Plase Enter room capacity" }
                    errorDetails[i] = { ...obj, rooms_details: rooms_details }
                    this.setState({ floorAndRoomDetails: errorDetails })
                    isError = true;
                    return true
                }

            })
        })

        if (isError == true) {
            return ""
        }


        let floorDetails = [];

        this.state.floorAndRoomDetails.map((item) => {

            console.log("item", item);
            let roomData = [];

            item.rooms_details.map((item2) => {
                roomData.push({ room_id: parseInt(item2.room_id), room_capacity: parseInt(item2.room_capacity), room_name: item2.room_name.toString() })
            });

            floorDetails.push({ hostel_building_floor_id: parseInt(item.hostel_building_floor_id), floor_name: item.floor_name.toString(), floor_incharge_id: item.floor_incharge_id, rooms_details: roomData })
        })

        console.log("params", floorDetails);

        const params = {
            branch_id: parseInt(this.state.branch_id),
            institute_id: parseInt(Cookies.get("institutionid")),
            hostel_building_name: this.state.buildingName,
            hostel_building_id: this.state.hostel_building_id,
            inserted_by: parseInt(Cookies.get("id")),
            floors_details: floorDetails,
        }

        this.setState({ loadingSpinner: 1 })

        console.log("params", params);

        // return ""


        this.addRoomsFloorsDetails(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0 });
            setTimeout(() => {
                this.props.onHide();
                window.location.reload(false);
            }, 1500);

        });
    };





    addRoomsFloorsDetails = async params => {
        await this.props.addRoomsFloorsDetails({
            variables: {
                params
            },
            update: (store, { data }) => {
                console.log("data777", data);
                if (data.addRoomsFloorsDetails) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }

            }
        })
    }

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };

    handleMultipleSelectInputChange = (e, name, i) => {

        console.log("handleMultipleSelectInputChange", e, name, i);

        if (name == "incharges") {
            let selectedIncharges = [];
            let selectedInchargesValues = [];

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const incharges = e[i];
                    const newObj = {
                        label: incharges.label,
                        value: incharges.value
                    }
                    selectedIncharges.push(newObj);
                    selectedInchargesValues.push(newObj.value);
                }

                let floorAndRoomDetails = [];

                this.state.floorAndRoomDetails.map((item, index) => {
                    if (index == i) {
                        floorAndRoomDetails.push({ ...item, floor_incharge_id: selectedInchargesValues.toString(), selected_floor_incharge_details: selectedIncharges, floorInchargeError: "" })
                    } else {
                        floorAndRoomDetails.push({ ...item, floorInchargeError: "" })
                    }
                })

                this.setState({ floorAndRoomDetails: floorAndRoomDetails })
                console.log("dddd", selectedIncharges, selectedInchargesValues.toString());
            }
        }
    }

    toggleDisplayedFloor = (e, floorId) => {
        e.preventDefault();
        this.setState({
            displayedFloors: floorId
        })
    };


    deleteRoom = (e, val, data) => {
        console.log("data", data, val);
        if (window.confirm("Are you sure you want delete room ?")) {
            let data = [];
            this.state.floorAndRoomDetails.map((item, index) => {
                if (index == this.state.displayedFloors) {
                    let roomsData = item.rooms_details.filter((item1, index1) => index1 != val)
                    data.push({ ...item, rooms_details: roomsData, noOfRooms: item.noOfRooms - 1 })
                } else {
                    data.push({ ...item })
                }
            });
            this.setState({ floorAndRoomDetails: data })
        }
    }

    deleteFloor = (val) => {
        if (window.confirm("Are you sure you want delete floor ?")) {
            let data = this.state.floorAndRoomDetails.filter((item, index) => index != val)
            this.setState({ floorAndRoomDetails: data, noOfFloors: data.length })
        }
    }

    addRoom = () => {

        let newData = [{ hostel_building_floor_id: null, floor_name: `Floor`, noOfRooms: "", capacityOfEachRooms: "", rooms_details: [], floor_incharge_id: "", noOfRoomsError: "", selected_floor_incharge_details: [], floorNamesError: "", floorInchargeError: "" }]
        let newRoomData = [...this.state.floorAndRoomDetails, ...newData];
        this.setState({ floorAndRoomDetails: newRoomData, noOfFloors: this.state.noOfFloors + 1 })
    }

    render() {



        console.log("maheshprops", this.props);
        console.log("maheshstate", this.state);

        const { floorAndRoomDetails, displayedFloors } = this.state;


        let floorInchargeSelectAll = true;
        let inchargelabelledby = "Select";
        let inchargedisablesearch = false;

        if (this.state.getEmployees.length > 0) {
            floorInchargeSelectAll = true;
            inchargedisablesearch = false;
        } else {
            inchargedisablesearch = true;
            floorInchargeSelectAll = false;
            inchargelabelledby = "incharge";
        }

        let roomData = [];
        if (this.state.floorAndRoomDetails != undefined) {
            roomData = this.state?.floorAndRoomDetails?.filter((item, index) => index == this.state.displayedFloors);
        }
        console.log("roomData", roomData);

        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-venter"
                centered
            >
                <div style={{ backgroundColor: "#F6FDFF" }}>
                    <Modal.Header closeButton>
                        <Modal.Title id="example-modal-sizes-title-lg h6 fw-bold">Building Creation
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-4" >
                        <section className='student-table'>
                            <Container>
                                <Form>
                                    <Form.Row>
                                        <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectClass">
                                            <Form.Label className="text-uppercase font-weight-bold nani">Branch</Form.Label>
                                            <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch_id} isInvalid={this.state.branchError} disabled={this.state.existingFloorAndRooms.length > 0 ? true : false}>
                                                <option value={""}>--Select Branch--</option>
                                                {this.props.globals.globalBranches.map(branchdata => (
                                                    <option key={branchdata.id} value={branchdata.id} >
                                                        {branchdata.branch_name}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                            <Form.Text className="form-text text-danger" type="invalid">{this.state.branchError}</Form.Text>
                                        </Form.Group>

                                        <Form.Group as={Col} lg={4} md={12} sm={12} controlId="formGridBuildingName">
                                            <Form.Label className='font-weight-bold'><span className="text-danger"></span>Enter Building Name</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Building Name" name='buildingName' onChange={(e) => { this.selecthandleInputChange(e) }} value={this.state.buildingName} />
                                            <span className="text-danger ml-2">{this.state.buildingNameError}</span>
                                        </Form.Group>

                                        <Form.Group as={Col} lg={4} md={12} sm={12} controlId="formGridnoOFloors">
                                            <Form.Label className='font-weight-bold'><span className="text-danger"></span>No.Of Floors</Form.Label>
                                            <Form.Control type="number" placeholder="Enter No.Of Floors" name='noOfFloors' onChange={(e) => { this.selecthandleInputChange(e) }} value={this.state.noOfFloors} disabled={this.state.existingFloorAndRooms.length > 0 ? true : false} />
                                            <span className="text-danger ml-2">{this.state.noOfFloorsError}</span>
                                        </Form.Group>

                                        {this.state.noOfFloors > 0 && (

                                            <Row>
                                                <Col lg={3} md={3} sm={12}>
                                                    <h6 className="text-center">Floor Name</h6>
                                                </Col>

                                                <Col lg={3} md={3} sm={12}>
                                                    <h6 className="text-center">Incharge Name</h6>
                                                </Col>

                                                <Col lg={3} md={3} sm={12}>
                                                    <h6 className="text-center">No Of Rooms</h6>
                                                </Col>

                                                <Col lg={3} md={3} sm={12}>
                                                    <h6 className="text-center Headings">Capacity Of Room</h6>
                                                </Col>
                                            </Row>
                                        )}


                                        {
                                            this.state.floorAndRoomDetails.length > 0 ? (
                                                this.state.floorAndRoomDetails.map((item, i) => {
                                                    return (
                                                        <Row>
                                                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="formGridnoOFloors">
                                                                <Form.Control type="text" placeholder="Enter Floors Name" name='floor_name' onChange={(e) => { this.selecthandleInputChange(e, i) }} value={item.floor_name} />
                                                                <span className="text-danger ml-2">{item.floorNamesError}</span>
                                                            </Form.Group>

                                                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="formGridnoOFloors">
                                                                <MultiSelect
                                                                    overrideStrings={{
                                                                        allItemsAreSelected: "All Incharges are selected.",
                                                                        selectSomeItems: inchargedisablesearch,
                                                                    }}
                                                                    disableSearch={inchargedisablesearch}
                                                                    hasSelectAll={floorInchargeSelectAll}
                                                                    options={this.state.getEmployees}
                                                                    value={item.selected_floor_incharge_details}
                                                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "incharges", i)}
                                                                    labelledBy={"floor_incharge"}

                                                                />
                                                                <Form.Text className="form-text text-danger">
                                                                    {item.floorInchargeError}
                                                                </Form.Text>

                                                            </Form.Group>


                                                            <Form.Group as={Col} lg={2} md={12} sm={12} controlId="formGridnoOFloors">
                                                                <Form.Control type="number" placeholder="Number Of Rooms" name='noOfRooms' onChange={(e) => { this.selecthandleInputChange(e, i) }} value={item.noOfRooms} disabled={item.hostel_building_floor_id != null || item.floor_name == "" ? true : false} />
                                                                <Form.Text className="form-text text-danger">
                                                                    {item.noOfRoomsError}
                                                                </Form.Text>
                                                            </Form.Group>

                                                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="formGridnoOFloors">
                                                                <Form.Control type="number" placeholder="capacityOfEachRooms" name='capacityOfEachRooms' onChange={(e) => { this.selecthandleInputChange(e, i) }} value={item.capacityOfEachRooms} disabled={item.hostel_building_floor_id != null || item.noOfRooms == "" ? true : false} />
                                                                <Form.Text className="form-text text-danger">
                                                                    {item.roomCapacityError}
                                                                </Form.Text>
                                                            </Form.Group>


                                                            {
                                                                this.state.existingFloorAndRooms.length > 0 ? (
                                                                    <Form.Group as={Col} lg={1} md={12} sm={12} controlId="formGridnoOFloors">
                                                                        <Button variant="link" name="delete" className="text-danger" onClick={(e) => { this.deleteFloor(i) }}><i className="far fa-trash-alt" /></Button>
                                                                    </Form.Group>

                                                                ) : ("")
                                                            }




                                                        </Row>
                                                    )
                                                })
                                            ) : ("")
                                        }

                                    </Form.Row>
                                </Form>


                                {
                                    this.state.existingFloorAndRooms.length > 0 ? (
                                        <Row>
                                            <Col>
                                                <Button className="btn btn-warning mb-2" style={{ marginLeft: "280px" }} onClick={this.addRoom}>
                                                    Add Floor</Button>
                                            </Col>
                                        </Row>
                                    ) : ("")
                                }

                                <Row className="BuildingCreation">
                                    {floorAndRoomDetails.map((floorDetails, index) => {
                                        return (
                                            <Col lg={2} md={2} sm={12}>

                                                <button className={this.state.displayedFloors == index ? "active block_view" : " block_view"}
                                                    onClick={(e) => this.toggleDisplayedFloor(e, index)}
                                                    style={{
                                                        color: "blue",
                                                        textAlign: "center",
                                                        marginRight: "10px",
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        marginBottom: "20px",
                                                        color: "black",
                                                        backgroundColor: "#fff",
                                                        borderRadius: "8px"
                                                    }}
                                                >
                                                    {floorDetails.floor_name}
                                                </button>

                                            </Col>
                                        );
                                    })}
                                </Row>

                                <Row>
                                    {
                                        roomData.length > 0 ? (
                                            roomData[0]?.rooms_details.length > 0 ? (
                                                roomData[0].rooms_details.map((item, index) => (
                                                    <Col className="form-group d-flex" key={index}>
                                                        <div>
                                                            <h6 className="text-center">Room No</h6>
                                                            <input type="text" name="room_name" className="room-name-input" placeholder="No"
                                                                onChange={(e) => { this.selecthandleInputChange(e, index) }}
                                                                value={item.room_name}
                                                            />
                                                            <br />
                                                            <span className="text-danger text-center">{item.roomNamesError}</span>
                                                        </div>
                                                        <div className="ml-2">
                                                            <h6 className="text-center">Capacity</h6>
                                                            <input
                                                                type="number" name="room_capacity" className="room-name-input" placeholder="Capacity"
                                                                onChange={(e) => { this.selecthandleInputChange(e, index) }}
                                                                value={item.room_capacity}
                                                                disabled={item.room_name !== "" ? false : true}
                                                            />
                                                            <br />
                                                            <span className="text-danger text-center">{item.roomEachCapacityError}</span>
                                                        </div>
                                                        {
                                                            this.state.existingFloorAndRooms.length > 0 ? (
                                                                <div className="ml-2 mt-3">
                                                                    <Button variant="link" name="delete" className="text-danger" onClick={(e) => { this.deleteRoom(item, index, roomData) }}><i className="far fa-trash-alt" /></Button>
                                                                </div>

                                                            ) : ("")
                                                        }
                                                    </Col>
                                                ))

                                            ) : ("")


                                        ) : ("")
                                    }

                                </Row>

                                {
                                    this.state.floorAndRoomDetails.length > 0 ? (
                                        <Row>
                                            <Col>
                                                <Form.Group as={Col} lg={12} md={12} sm={12} controlId="SelectBranch">
                                                    <Button className="btn btn-success" style={{ marginLeft: "280px" }} onClick={(e) => this.getDisplayData()} type="submit">
                                                        {
                                                            this.state.loadingSpinner == 1 ? (
                                                                <span className="spinner-border spinner-border-sm"></span>
                                                            ) : ""
                                                        }
                                                        Submit</Button>

                                                    <div className='d-block'>
                                                        {this.state.currentStep == 5 ? (
                                                            <Form.Text className="form-text text-Success " style={{ textAlign: "center" }}>
                                                                <p style={{ color: "green" }}>successfully Submitted</p>
                                                            </Form.Text>
                                                        ) : (
                                                            <Form.Text className="form-text text-danger" style={{ textAlign: "center", display: "none" }}>
                                                                {this.state.submitError}
                                                            </Form.Text>
                                                        )}
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                    ) : null
                                }
                            </Container>
                        </section>

                    </Modal.Body>
                </div>
            </Modal>
        )
    }
}


export default withRouter(withApollo(compose(
    graphql(ADD_BUILDING_ROOMS_FLOORS_DETAILS, {
        name: "addRoomsFloorsDetails"
    }),
)(BuildingCreationModal))
);